import { readdirSync, readFileSync } from 'fs'
import matter from 'gray-matter'
import path from 'path'

const getModelsForLocale = (locale: string) => {
  const MODELS_DIR = path.join(process.cwd(), `./src/content/${locale}/models`)
  const files = readdirSync(MODELS_DIR)
  const modelData = files.map((file) => {
    const fullPath = path.join(MODELS_DIR, file)
    const contents = readFileSync(fullPath, 'utf8')
    const { data } = matter(contents)

    return data
  })

  return modelData.sort((a, b) => (a.order > b.order ? 1 : -1))
}

const getModels = (locale: string | undefined, type?: string) => {
  let modelData = []

  if (locale === 'kinto') {
    const toyotaModels = getModelsForLocale('toyota')
    const lexusModels = getModelsForLocale('lexus')

    const filteredToyotaModels = toyotaModels.filter((model) => {
      if (type === 'bch-get-a-quote') {
        return model.active && model.visibility.show_kinto_request_a_callback
      }
      return model.active
    })

    const filteredLexusModels = lexusModels.filter((model) => {
      if (type === 'bch-get-a-quote') {
        return model.active && model.visibility.show_kinto_request_a_callback
      }
      return model.active
    })

    return {
      toyotaModels: filteredToyotaModels,
      lexusModels: filteredLexusModels,
    }
  }
  modelData = getModelsForLocale(locale)

  modelData = modelData.filter((model) => {
    if (type === 'brochure') {
      return model.active && model.visibility.show_brochure
    }

    if (type === 'test-drive') {
      return model.active && model.visibility.show_testdrive
    }

    if (type === 'newsletter') {
      return model.active && model.visibility.show_newsletter
    }

    if (type === 'video-consulation') {
      return model.active && model.visibility.show_video_consulation
    }

    if (type === 'internal-cans') {
      return model.active && model.visibility.show_internal_cans
    }

    if (type === 'request-a-callback') {
      return model.active && model.visibility.show_request_a_callback
    }

    if (type === 'kmi') {
      return model.active && model.visibility.show_kmi
    }

    if (type === 'get-a-quote') {
      return model.active && model.visibility.show_get_a_quote
    }

    if (type === 'kinto-bch-get-a-quote') {
      return model.active && model.visibility.show_kinto_request_a_callback
    }

    if (type === 'power-of-choice') {
      return model.active && model.visibility.show_power_of_choice
    }

    if (type === 'toyota-thon') {
      return model.active && model.visibility.show_toyota_thon
    }

    return model.active
  })

  // Sort the modelData array based on the name property
  if (type !== 'brochure' && type !== 'test-drive' && type !== 'get-a-quote') {
    modelData.sort((a, b) => a.name.localeCompare(b.name))
  }

  return modelData
}

export default getModels
